module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group d-flex"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason.description),
      expression: "reason.description"
    }],
    staticClass: "w-50",
    attrs: {
      "type": "text",
      "placeholder": "Description here"
    },
    domProps: {
      "value": (_vm.reason.description)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reason, "description", $event.target.value)
      }, function($event) {
        return _vm.descriptionIsReadyToSave($event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', [_vm._v("Cancelation Reason Type")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "reduce": function (name) { return name.id; },
      "options": _vm.reasonTypesOptions
    },
    on: {
      "input": function($event) {
        _vm.reason.reasonType = _vm.reasonTypeObject.id
      }
    },
    model: {
      value: (_vm.reasonTypeObject),
      callback: function($$v) {
        _vm.reasonTypeObject = $$v
      },
      expression: "reasonTypeObject"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name"), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac5d3958"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/cancellationReasons/cancellationReasonsForm.vue
// module id = 1967
// module chunks = 0